import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M10.563 16.436c.467.042.947.064 1.437.064 4.694 0 8.5-2.015 8.5-4.5 0-1.213-.906-2.313-2.379-3.122M13.436 7.564A16.019 16.019 0 0012 7.5c-4.694 0-8.5 2.015-8.5 4.5 0 1.212.905 2.312 2.376 3.121"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 5L5 19"
    })
  ]))
}